import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { CircularProgress, Button as MUIButton } from '@mui/material';
import {
    Check,
    Cancel,
    Save,
    Edit,
    Delete,
    Add,
    ArrowForward,
    ArrowBack,
    HelpOutline,
} from "@mui/icons-material";
import CancelIcon from '@mui/icons-material/Cancel';

const Button = (props) => {
    const { comp,
        btnProcessStatus,
        isDisabled,
        setIsDisabled,
        isEdit,
        validate,
        doSubmit,
        handleClose,
        size = "btn-sm",
        currentButtonType,
        handleSubformModalShowHide
    } = props;

    const [alertMessages, setAlertMessages] = useState([]);
    //const buttonAlertMessagesSelector = useSelector(getButtonAlertMessages);
    // const dispatch = useDispatch();

    // useEffect(() => {
    //     if (comp?.formProcess > 0)
    //         dispatch(loadButtonAlertMessages(comp.formProcess));
    // }, []);

    // useEffect(() => {
    //     setAlertMessages(buttonAlertMessagesSelector);
    // }, [buttonAlertMessagesSelector])

    if (!comp) return;

    const closeBtn = ["close", "exit", "back"];
    const saveBtn = ["submit", "saveAndContinue", "saveAndExit", "save", "taskCompleted", "checkStatus", "home"];
    const updBtn = ["update", "updateAndContinue", "updateAndExit"];

    const commonButtonStyle = {
        fontSize: "14px",
        fontWeight: 600,
        fontFamily: "Open Sans, sans-serif",
        minHeight: "37px",
        height: "37px",
        textTransform: "none",
    };

    const handleSubformModalShowHide1 = (name) => {
        const modelId = name.split("-");
        if (modelId.length > 1)
            this.setState({
                [modelId[0]]: !this.state[modelId[0]],
                subformItemIndex: modelId[1],
            });
        else this.setState({ [name]: !this.state[name], subformItemIndex: -1 });
    };

    const handleEditForm = async () => {
        // const result = await getConfirmAlert("Are you sure?", "You want to Edit this Form", "warning");
        // if (result.isConfirmed)
        //     setIsDisabled(false)
    };

    const handleSubmit = async (e) => {
        const targetval = e.currentTarget;
        e.preventDefault();
        const processId = targetval.dataset.process;
        if (parseInt(processId) > 0) {
            const msg = alertMessages.filter(x => x.formProcessId === parseInt(processId));
            if (msg.length > 0) {
                const alMsg = msg[0];
                if (alMsg.isConfirmMessage) {
                    // const result = await getConfirmAlert("", alMsg.processItem, "warning");
                    // if (result.isConfirmed) {
                    //     doSubmit(targetval, "Saved Successfully");
                    // }
                    doSubmit(targetval, "Saved Successfully");
                } else {
                    doSubmit(targetval, alMsg.processItem);
                }
            }
            else {
                doSubmit(targetval, "");
            }
        }
        else {
            doSubmit(targetval, "");
        }

    };

    const getButtonStyle = (style) => {
        const styles = [
            "secondary",
            "success",
            "danger",
            "warning",
            "info",
            "light",
            "dark",
        ];

        for (let s of styles) {
            if (style.includes(s)) {
                return s;
            }
        }

        return "primary";
    }

    const getMUIButtonProps = (style = "") => {
        const props = {
            color: "primary",
            size: "medium",
            variant: "contained"
        };

        // if (style.includes("danger")) props.color = "error";
        // else if (style.includes("success")) props.color = "success";
        // else if (style.includes("warning")) props.color = "warning";
        // else if (style.includes("info")) props.color = "info";
        // else if (style.includes("secondary")) props.color = "secondary";
        // else if (style.includes("primary")) props.color = "primary";
        // else if (style.includes("dark")) props.color = "inherit";

        // if (style.includes("outline")) props.variant = "outlined";
        // else props.variant = "contained";

        // if (style.includes("btn-sm")) props.size = "small";
        // else if (style.includes("btn-lg")) props.size = "large";

        return props;
    };

    const mapFAIconToMUI = (faClass = "") => {
        if (faClass.includes("fa-check")) return <Check />;
        if (faClass.includes("fa-times") || faClass.includes("fa-close")) return <Cancel />;
        if (faClass.includes("fa-save")) return <Save />;
        if (faClass.includes("fa-edit")) return <Edit />;
        if (faClass.includes("fa-trash")) return <Delete />;
        if (faClass.includes("fa-plus")) return <Add />;
        if (faClass.includes("fa-arrow-right")) return <ArrowForward />;
        if (faClass.includes("fa-arrow-left")) return <ArrowBack />;
        if (faClass.includes("fa-question")) return <HelpOutline />;
        if (faClass.includes("fa-spinner fa-spin")) return <HelpOutline />;
        return null;
    };

    if (comp.buttonType?.type === "subform") {
        return (
            <button
                type="button"
                onClick={() => handleSubformModalShowHide && handleSubformModalShowHide("showHide" + comp.subform)}
                className={`${comp?.cssclass ? comp.style + " " + comp.cssclass : comp.style} ${size}`}
                disabled={isDisabled}
            >
                {comp?.formIcons && <i className={`${comp.formIcons} mr-1`} aria-hidden="true"></i>}
                {comp.label}
            </button>
        );
    }

    if (comp.buttonType.type === "editForm") {
        return (
            <button
                type="button"
                name={comp.buttonType.type}
                data-process={comp?.formProcess ? 0 : comp.formProcess}
                className={`form-group ${comp?.cssclass ? comp.style + " " + comp.cssclass : comp.style} ${size}`}
                onClick={handleEditForm}
                aria-label={comp.label}
            >
                {comp?.formIcons && <i className={`${comp.formIcons} mr-2`} aria-hidden="true"></i>}
                {comp.label}
            </button>
        );
    }

    if (comp.buttonType.type === "help") {
        return (
            <button
                type="button"
                name={comp.buttonType.type}
                data-process={comp?.formProcess ? 0 : comp.formProcess}
                className={`${comp?.cssclass ? comp.style + " " + comp.cssclass : comp.style} ${size}`}
                //disabled={this.validate()}
                //onClick={this.handleSubmit}
                aria-lable={comp.label}
            >
                {comp?.formIcons && <i className={`${comp.formIcons} mr-2`} aria-hidden="true"></i>}
                {comp.label}
            </button>
        );
    }

    if (closeBtn.indexOf(comp.buttonType.type) > -1) {
        // const muiButtonProps = getMUIButtonProps(comp.style);
        return (
            <MUIButton
                variant={"outline"}
                name={comp.buttonType.type}
                data-process={comp?.formProcess ? 0 : comp.formProcess}
                onClick={handleClose}
                className={`${comp?.cssclass}`}
                startIcon={comp?.formIcons ? mapFAIconToMUI(comp.formIcons) : <CancelIcon />}

            >
                {/* {comp?.formIcons && mapFAIconToMUI(comp.formIcons)} */}
                {comp.label}
            </MUIButton>
        );
    }

    if (saveBtn.indexOf(comp.buttonType.type) > -1) {
        const muiButtonProps = getMUIButtonProps(comp.style);
        return (!isEdit || isEdit === true || isDisabled)
            && <MUIButton
                variant={muiButtonProps.variant}
                color={muiButtonProps.color}
                name={comp.buttonType.type}
                size={muiButtonProps.size}
                onClick={handleSubmit}
                data-process={comp?.formProcess}
                className={`${comp?.cssclass}`}
                disabled={btnProcessStatus || isDisabled || validate()}
                startIcon={((!btnProcessStatus && comp?.formIcons) || (currentButtonType !== comp.buttonType.type)) ? mapFAIconToMUI(comp.formIcons)
                    : btnProcessStatus && currentButtonType === comp.buttonType.type && <CircularProgress size={16} color="inherit" />}
            >
                {comp.label}
            </MUIButton>

    }

    if (updBtn.indexOf(comp.buttonType.type) > -1) {
        return (
            !isEdit && isEdit === false && !isDisabled && (
                <MUIButton
                    variant="contained"
                    name={comp.buttonType.type}
                    data-process={comp?.formProcess ? 0 : comp.formProcess}
                    onClick={handleSubmit}
                    disabled={btnProcessStatus || validate()}
                    className={`${comp?.cssclass}`}
                    startIcon={
                        btnProcessStatus
                            ? <CircularProgress size={16} color="inherit" />
                            : comp?.formIcons && mapFAIconToMUI(comp.formIcons)
                    }
                >
                    {comp.label}
                </MUIButton>
            )
        );
    }

    return "";
}

export default Button;